import { render, staticRenderFns } from "./PublisherSearchBar.vue?vue&type=template&id=f1db59ec&lang=pug"
import script from "./PublisherSearchBar.vue?vue&type=script&lang=js"
export * from "./PublisherSearchBar.vue?vue&type=script&lang=js"
import style0 from "./PublisherSearchBar.vue?vue&type=style&index=0&id=f1db59ec&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports